export const getSortField = (state) => state.getIn(['sorting', 'field']);
export const getSortOrder = (state) => state.getIn(['sorting', 'order']);
export const getPToken = (state) => state.getIn(['sorting', 'pToken']);
export const getOriginalSortBy = (state) =>
  state.getIn(['sorting', 'originalSortBy']);
